import { render, staticRenderFns } from "./Importacao.vue?vue&type=template&id=188268b3&"
import script from "./Importacao.vue?vue&type=script&lang=js&"
export * from "./Importacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports